<template>
  <div class="w-max">
    <div class="bordered-box" :class="paddingClass">
      <add-plus-icon  width="50" height="50" class="m-auto"/>
      <div class="add-text">{{ $t("add") }} {{ message }}</div>
    </div>
  </div>
</template>
<script>
import AddPlusIcon from '@/assets/icons/vue/add.vue';

export default {
  components: { AddPlusIcon },
  props: {
    message: {
      type: String,
      required: true,
    },
    paddingX: {
      type: String,
      required: false,
    },
    paddingY: {
      type: String,
      required: false,
    },
  },
  computed: {
    paddingClass() {
      return this.padding ? `px-${this.paddingX} py-${this.paddingY}` : 'px-90 py-50';
    },
  },
};
</script>
<style  lang='css' scoped>
.bordered-box {
  @apply border-dashed
  border rounded border-default cursor-pointer;
}
.add-text {
  @apply font-semibold text-18 text-center;
}
</style>
